import type { FC } from 'react';

import { ArrowPathIcon, ChatBubbleOvalLeftIcon, HandThumbUpIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';

import ShareIcon from '~/components/Icons/ShareIcon';

import { actionIconClass } from '../constants';

interface PostActionsSkeletonProps {
  className?: string;
}

export const PostActionsSkeleton: FC<PostActionsSkeletonProps> = ({ className }) => (
  <div className={classNames('flex items-center justify-between px-2 pb-4', className)}>
    <div className="flex items-center h-8 px-2 py-1 rounded-full">
      <HandThumbUpIcon className={actionIconClass} />
    </div>
    <div className="flex items-center h-8 px-2 py-1 rounded-full">
      <ChatBubbleOvalLeftIcon className={actionIconClass} />
    </div>
    <div className="flex size-8 items-center justify-center rounded-full">
      <ArrowPathIcon className={actionIconClass} />
    </div>
    <div className="flex size-8 items-center justify-center rounded-full">
      <ShareIcon className={actionIconClass} fill="none" />
    </div>
  </div>
);
